import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'iconfontSvg',
  props: {
  icon: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props



const iconName = computed(() => `#${props.icon}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(['icon', __props.customClass]),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_1)
  ], 2))
}
}

})